const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const generateUUID = () => {
    return crypto.randomUUID()
}

export const isValidUUID = (uuid: string) => {
    return UUID_REGEX.test(uuid)
}
